<template>
  <div class="login container">
    <div v-if="!redeemTicketPermission()" class="pt-5">
      <h2>Sorry, you do not have permissions to access this feature.</h2>
    </div>
    <form v-else @submit.prevent="$nextTick(submit)">

      <div class="d-flex justify-content-between">
        <div class="col-xs-6 pl-3 pt-5">
          <cta link="home" shape="circle" icon="left-arrow" text="" margin="no-margin" />
        </div>

        <div class="col-xs-6  pr-3 pt-5">
          <cta type="submit" shape="circle" text="" icon="right-arrow" :disabled="!ticket_reference || errors.has('ticket_reference')" margin="no-margin" :loading="submitted" />
        </div>
      </div>

      <p class="small-header-text">Ticket code</p>
      <h2>{{computed_ticket_reference}}</h2>
      <div class="spacer"></div>

      <p class="small-header-text mt-4">Event details</p>
      <p class="large-header-text">{{ticket.Product.name}}</p>
      <div class="spacer"></div>

      <p class="medium-header-text">{{ticket.PriceModifier.description}}</p>
      <p class="medium-header-text">{{ticket_local_time}}</p>
      <p class="medium-header-text">{{ticket_date}}</p>
      <p class="medium-header-text">{{ticket_location}}</p>

      <div class="row d-flex justify-content-center ticket-cta-container">

        <div class="d-flex justify-content-center pt-4 pb-4">
          <cta link="home" text="Cancel"/>
        </div>
        <div class="d-flex justify-content-center pt-4 pb-4">
          <cta type="submit" text="Confirm"/>
        </div>

      </div>

    </form>

  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'Login',
  components: {
  },
  inject: ['$validator'],
  data : function(){       
      return {
        ticket_reference: '',
        submitted     : false,
        error:'',
        destroyed: false
      };

  },
  created:function(){
  },

  computed: {

    account(){
      return this.$store.getters.getAccount;
    },
    
    ticket() {
      return this.$store.getters.getTicket;
    },

    unitId(){
      return this.$store.getters.getUnit.id;
    },

    /**
     * Format the local time into a string
     */
    ticket_local_time() {
      return moment(this.ticket.EventSlot.local_time, "HH:mm:ss").format('h:mma');
    },

    /**
     * Format the event date into a string
     */
    ticket_date() {
      return moment(this.ticket.event_datetime).format('Do MMMM YYYY');
    },

    /**
     * Match up ticket unit_id with the name of the unit
     */
    ticket_location() {
      let ticket_unit = this.ticket.unit_id;
      let allUnits = this.ticket.Product.TicketProductConfig.Units;
      return allUnits.filter(unit => unit.id == ticket_unit)[0].name;
    },

    computed_ticket_reference() {
      return this.ticket.ticket_reference
    }
 
  },
  methods:{

    submit() {

      this.$validator.validateAll().then((result) => {
        if(result){

          this.submitted = true;

          window.axios({
            url: process.env.VUE_APP_API_GRAPH_URL,
            method: 'post',
            data: {
              query: `
                mutation(
                  $ticket_reference:String!, 
                  $unit_id:Int!) {
                    redeemTicket(
                      ticket_reference    :$ticket_reference, 
                      unit_id             :$unit_id) 
                    {
                      id
                    },
                }
              `,
              variables: {
                ticket_reference: this.ticket.ticket_reference,
                unit_id: this.unitId
              }
            }
          }).then((result) => {

            if(result.data.data && result.data.data.redeemTicket){

              // Go to success page
              this.$router.push({ name: 'redeem-ticket-success'});

            } else if(result.data.errors && result.data.errors.length){

              // Go to error page with correct message
              if (result.data.errors[0].validation['unit_id']){
                this.$bus.$emit('error_message', result.data.errors[0].validation['unit_id'][0]);
              } else if (result.data.errors[0].validation.ticket_reference[0] == "Already redeemed.") {
                this.$router.push({ name: 'redeem-ticket-error', params: { "message": "Ticket already used."}});
              } else if (result.data.errors[0].validation.ticket_reference[0] == "Not found.") {
                this.$router.push({ name: 'redeem-ticket-error', params: { "message": "Ticket not found."}});
              } else if (result.data.errors[0].validation.ticket_reference[0] == "Order has been cancelled") {
                this.$router.push({ name: 'redeem-ticket-error', params: { "message": "This ticket has been cancelled."}});
              } else {
                this.$bus.$emit('error_message', 'Something went wrong, please try again!');
              }
            }
          }).catch(err => {
              this.$bus.$emit('error_message', 'Something went wrong, please try again!');
          }).then(() => {
              this.submitted = false;
          });
          
        }
      });

      },

  }
}
</script>

<style scoped>
.loader {
  position: absolute;
}

.small-header-text {
  font-size: 1.3em;
  margin: 0;
}

.medium-header-text {
  font-size: 1.6em;
  margin: 0;
}

.large-header-text {
  font-size: 2.7em;
}

.spacer {
  height: 1em;
}

.ticket-cta-container {
  column-gap: 4em;
}
</style>